import {ContentAnnotation} from "../helpers";

class AnnotationSubject {
  private readonly observers: AnnotationObserver[] = [];

  public subscribe(observer: AnnotationObserver) {
    this.observers.push(observer);
  }

  public notify(event: AnnotationEvent, note: ContentAnnotation) {
    switch (event) {
      case AnnotationEvent.TAKING_NOTES:
        this.notifyTakingNotes(note);
        break;
      case AnnotationEvent.NOTE_CREATED:
        this.notifyNoteCreated(note);
        break;
      case AnnotationEvent.NOTE_SELECTED:
        this.notifyNoteSelected(note);
        break;
      case AnnotationEvent.NOTE_UPDATED:
        this.notifyNoteUpdated(note);
        break;
    }
  }

  private notifyTakingNotes(note: ContentAnnotation) {
    for (const observer of this.observers) {
      observer.onTakingNote(note);
    }
  }

  private notifyNoteCreated(note: ContentAnnotation) {
    for (const observer of this.observers) {
      observer.onNoteCreated(note);
    }
  }

  private notifyNoteSelected(note: ContentAnnotation) {
    for (const observer of this.observers) {
      observer.onNoteSelected(note);
    }
  }

  private notifyNoteUpdated(note: ContentAnnotation) {
    for (const observer of this.observers) {
      observer.onNoteUpdated(note);
    }
  }

  private notifyNoteDeleted(note: ContentAnnotation) {
    for (const observer of this.observers) {
      observer.onNoteDeleted(note);
    }
  }
}

export interface AnnotationObserver {
  onTakingNote(note: ContentAnnotation): void;

  onNoteCreated(note: ContentAnnotation): void;

  onNoteSelected(note: ContentAnnotation): void;

  onNoteDeleted(note: ContentAnnotation): void;

  onNoteUpdated(note: ContentAnnotation): void;
}

export enum AnnotationEvent {
  TAKING_NOTES,
  NOTE_CREATED,
  NOTE_SELECTED,
  NOTE_UPDATED,
  NOTE_DELETED,
}

export const annotationSubject = new AnnotationSubject();